<input
  authorizeEnable
  [authorizeRegister]="registerPermission"
  type="text"
  [ngClass]="{
    'is-invalid': control.touched && control.invalid,
  }"
  class="form-control"
  [formControl]="control"
  [ngbTypeahead]="searchParentGroups"
  (focus)="focus$.next($any($event).target.value)"
  (click)="click$.next($any($event).target.value)"
/>
